module.exports = __webpack_public_path__ + "img/3140026.png";